import { render } from "./Rubrics.vue?vue&type=template&id=7b597530&ts=true"
import script from "./Rubrics.vue?vue&type=script&lang=ts"
export * from "./Rubrics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__